/**
 * src/pages/public/PortalFooter.jsx — the one place the Tattoo Lab brand
 * appears on a portal page.
 *
 * REDESIGN.md's Portal section: the portal should look like the studio's own
 * page, not Tattoo Lab's — this credit is deliberately small, quiet, and at
 * the very end, the only mention of the platform on an otherwise fully
 * studio-branded page. Shared by all the portal pages (BookingPortal,
 * FlashGallery, ConsentSign, JoinInvite, Unsubscribe) so the one line of copy
 * can't drift.
 *
 * The credit doubles as a backlink: every studio's /book and /gallery page
 * links to the marketing site. The anchor is the plain brand name rather than
 * a keyword phrase — the same keyword-stuffed anchor on hundreds of
 * third-party sites is exactly the footer-link pattern search engines
 * discount. The copy and URL live in lib/portal-credit.js because
 * src/worker.js also writes this link into the server-rendered HTML.
 *
 * The Privacy link is here because these are the pages where clients hand
 * over their data (bookings, consent forms), and it's where they'd look for
 * how it's handled. It points at the platform's policy, which explains that
 * the studio is the controller of their data.
 */
import {
  PORTAL_CREDIT_LABEL,
  PORTAL_CREDIT_PREFIX,
  PORTAL_CREDIT_URL,
} from '../../lib/portal-credit.js';

export default function PortalFooter() {
  return (
    <footer className="portal-footer">
      {PORTAL_CREDIT_PREFIX} <a href={PORTAL_CREDIT_URL}>{PORTAL_CREDIT_LABEL}</a>
      {' · '}
      <a href="https://www.tattoo-lab.co.uk/privacy">Privacy</a>
    </footer>
  );
}
